import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

// Preliminary chain key: chain not yet supported in Viem
export const okbchain = {
  displayName: 'OKExChain',
  runtime: 'evm',
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'okbchain' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
